export default {
  en: {
    'login.components.2fa-setup-panel.title': 'Two-factor authentication setup',
    'login.components.2fa-setup-panel.description':
      'You need to enable two-factor authentication before you can continue. Please enter the mobile phone number that you want to use for this.',
  },
};
